import { useClassName } from '@/styles/ContentArticleHeader';
import { PropsFromComponent, PropsFromSubcomponents } from '@/types/component';
import { GenericComponentFactory } from '../../GenericComponent';

export type ArticleHeaderProps = PropsFromComponent<typeof ArticleHeader>;
export type ArticleHeaderSubcomponentProps = PropsFromSubcomponents<typeof ArticleHeader>;

const GenericComponent = GenericComponentFactory({ useClassName });

const Base = GenericComponent({ as: 'header', styles: { key: '' } });
const Bylines = GenericComponent({ as: 'div', styles: { key: 'bylines' } });
const Category = GenericComponent({ as: 'div', styles: { key: 'category' } });
const Date = GenericComponent({ as: 'div', styles: { key: 'date' } });
const Description = GenericComponent({ as: 'div', styles: { key: 'description' } });
const Headline = GenericComponent({ as: 'h1', styles: { key: 'headline' } });
const Image = GenericComponent({ as: 'div', styles: { key: 'image' } });
const Tags = GenericComponent({ as: 'div', styles: { key: 'tags' } });

export const ArticleHeader = Object.assign(Base, {
  Bylines,
  Date,
  Category,
  Description,
  Headline,
  Image,
  Tags,
});
